// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { BottomField } from 'components/molecules/BottomField';
import LabelOrSelectField from 'components/molecules/LabelOrSelectField';
import styles from './RecycleComplete.module.scss';
import { useTranslation } from 'react-i18next';
import { FormApi } from 'final-form';
import { FormRenderProps } from 'react-final-form';
import { UserRecycleSiteForm } from 'util/siteManagementTypes';
import { Option } from 'util/Types';
import { useSelector } from 'react-redux';
import { selectUser } from 'redux/slices/userSlice';
import { ProcessingMode } from 'util/Enums';
import { useEffect, useState } from 'react';
import { createAxios } from 'ts/createAxios';
import { handleError } from 'util/errorHandler';

type RecycleInfoFormProps = {
  materialTypes: Option[];
  materialNameOptions: Option[];
  processingMethods: Option[];
  grades: Option[];
  packingStyles: Option[];
  formProps: FormRenderProps<UserRecycleSiteForm, Partial<UserRecycleSiteForm>>;
  prevProcessingObjectId: string | undefined;
  resetFormData: (
    form: FormApi<UserRecycleSiteForm, Partial<UserRecycleSiteForm>>
  ) => void;
  setStep: (step: 'regist' | 'info' | 'weight') => void;
  weightLeftTitle: string;
  weightLeftValue: string;
  setTotalAutoInputResourcesWeight: (data: number) => void;
  totalAutoInputResourcesWeight: number;
};

const RecycleInfoForm: React.FC<RecycleInfoFormProps> = ({
  materialTypes,
  materialNameOptions,
  processingMethods,
  grades,
  packingStyles,
  formProps,
  prevProcessingObjectId,
  resetFormData,
  setStep,
  weightLeftTitle,
  weightLeftValue,
  setTotalAutoInputResourcesWeight,
  totalAutoInputResourcesWeight,
}) => {
  const { t } = useTranslation();
  const user = useSelector(selectUser);
  const [isSettingMaster, setIsSettingMaster] = useState<boolean>(true);

  useEffect(() => {
    if (
      user.processingMode === ProcessingMode.Auto &&
      formProps.values.materialName &&
      formProps.values.materialTypeId
    ) {
      createAxios()
        .post('/recycle/remain-input-weight', {
          materialName: formProps.values.materialName,
          materialTypeId: Number(formProps.values.materialTypeId),
        })
        .then((response) => {
          setTotalAutoInputResourcesWeight(
            Number(response.data.remainInputWeight)
          );
          setIsSettingMaster(response.data.isSettingMaster);
        })
        .catch((error) => {
          handleError(error);
        });
    }
  }, [
    user.processingMode,
    formProps.values.materialName,
    formProps.values.materialTypeId,
  ]);

  return (
    <>
      <div className={styles.scrollContents}>
        <LabelOrSelectField
          options={materialNameOptions}
          label={t('user_recycle.material_name')}
          fieldName="materialName"
        />
        <LabelOrSelectField
          label={t('user_recycle.kind')}
          fieldName="materialTypeId"
          options={materialTypes}
          error={
            user.processingMode === ProcessingMode.Auto && !isSettingMaster
              ? t('messages.M_type_not_setting_master') || ''
              : undefined
          }
        />
        <LabelOrSelectField
          options={[]}
          label={weightLeftTitle}
          staticValue={`${weightLeftValue}kg`}
        />
        <LabelOrSelectField
          label={t('user_recycle.processing_method')}
          fieldName={'processingMethod'}
          options={processingMethods}
        />
        <LabelOrSelectField
          label={t('user_recycle.grade')}
          fieldName="gradeId"
          options={grades}
        />
        <LabelOrSelectField
          label={t('user_recycle.packing')}
          fieldName="packingStyle"
          options={packingStyles}
        />
      </div>

      <BottomField>
        <div className={styles.bottomBtn}>
          <button
            className={styles.btnBack}
            onClick={() => {
              if (prevProcessingObjectId) {
                resetFormData(formProps.form);
              }

              setStep('regist');
            }}
          >
            {t('common.return')}
          </button>
          <button
            className={styles.btnRequest}
            type="button"
            onClick={() => setStep('weight')}
            disabled={
              user.processingMode === ProcessingMode.Auto &&
              !totalAutoInputResourcesWeight
            }
          >
            {t('common.button.next')}
          </button>
        </div>
      </BottomField>
    </>
  );
};

export default RecycleInfoForm;
